import ElectricBolt from "@mui/icons-material/ElectricBolt";
import { Stack, Typography } from "@mui/material";

import type { StackProps } from "@mui/material";
import type { FC } from "react";

export const CoPilotHeader: FC<{ beta?: boolean } & StackProps> = (props) => (
  <Stack
    direction="row"
    {...props}
    sx={[
      {
        gap: 1,
        position: "relative",
        alignItems: "baseline",
      },
      ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
    ]}
  >
    <Typography variant="h6">
      <ElectricBolt fontSize="small" sx={{ position: "relative", top: "3px" }} />
      CoPilot
    </Typography>
    <Typography variant="body2" sx={{ color: "info.main" }}>
      beta
    </Typography>
  </Stack>
);
